import api from "../../services/axiosHeader.js";
import {allQuotes, favoritesDossier, listDocument, myProposals, proposal} from "../../../api/entryPoint";

function spliseArray(data) {
    while (data.length > 6) {
        data.splice(1, 1);
    }
    return data;
}

export const state = {
    folders: [],
    foldersProposals: [],
    favorites: [],
    allquotes: {},
    isLoading: true,
    isLoadingStats: true,
    isLoadingFavorites: true,
    isLoadingProposals: true,

}

export const mutations = {
    SET_IS_LOADING(state, payload) {
        state.isLoading = payload
    },
    SET_IS_LOADING_STATISTIQUES(state, payload) {
        state.isLoadingStats = payload
    },
    SET_FOLDERS(state, newValue) {
        state.folders = newValue
    },
    SET_FOLDERS_PROPOSALS(state, newValue) {
        state.foldersProposals = newValue
    },
    SET_FAVORITES(state, newValue) {
        state.favorites = newValue
    },
    SET_IS_LOADING_FAVORITES(state, newValue) {
        state.isLoadingFavorites = newValue
    },
    SET_IS_LOADING_PROPOSALS(state, newValue) {
        state.isLoadingProposals = newValue
    },
    SET_ALLQUOTES(state, newValue) {
        state.allquotes = newValue
    },
    SET_IS_LOADING_TITLE(state, payload) {
        state.isLoadingTitle = payload
    },
}

export const getters = {
    getList(state) {
        return state.folders;
    },
    getListProposals(state) {
        return state.foldersProposals;
    },
    getFavorites(state) {
        return state.favorites;
    },
    getIsLoading(state) {
        return state.isLoading;
    },
    getIsLoadingStatistiques(state) {
        return state.isLoadingStats;
    },
    getIsLoadingFavorites(state) {
        return state.isLoadingFavorites;
    },
    getIsLoadingProposals(state) {
        return state.isLoadingProposals;
    },
    getAllQuotes(state) {
        return state.allquotes;
    },
    getIsLoadingTitle(state) {
        return state.isLoadingTitle;
    },
}

export const actions = {
    // List les dernier  catalogs
    listDernierDossier({commit}) {
        commit('SET_IS_LOADING', true);
        api.get(listDocument + 1 + '&sort=-id')
            .then((res) => {
                if (res.data.items.length > 6) {
                    res.data.items = spliseArray(res.data.items);
                }
                commit('SET_FOLDERS', res.data.items);
                commit('SET_IS_LOADING', false);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    // list dernier favorites
    folderFavorites({commit}) {
        commit('SET_IS_LOADING_FAVORITES', true);
        api.get(favoritesDossier + localStorage.userId).then((res) => {
            if (res.data.items.length > 6) {
                res.data.items = spliseArray(res.data.items);
            }
            commit('SET_FAVORITES', res.data.items);
            commit('SET_IS_LOADING_FAVORITES', false);
        })
            .catch((error) => {
                console.log(error);
            });
    },
    // List dernier Propositions
    listProposals({commit}) {
        commit('SET_IS_LOADING_PROPOSALS', true);
        let data
        api.get(myProposals + '?page=' + 1).then((res) => {
            if (res.data.items.length > 6) {
                res.data.items = spliseArray(res.data.items);
            }
            commit('SET_FOLDERS_PROPOSALS', res.data.items);
            data = res.data.items;
            commit('SET_IS_LOADING_PROPOSALS', false);
            commit('SET_IS_LOADING_TITLE', true);
            let dataInjected = [];
            api.get(proposal + '?page=1').then((resultat) => {
                dataInjected = data.map((el) => {
                    let temp = resultat.data.find(element => element.id === el.request);
                    if (temp) {
                        el.req = temp;
                    }
                    return el;
                });
                data.items = dataInjected;
                commit('SET_FOLDERS_PROPOSALS', dataInjected);
                commit('SET_IS_LOADING_TITLE', false);
            })
        }).catch((error) => {
            console.log(error);
        });
    },


    // champs statistiques
    listStatistique({commit}) {
        commit('SET_IS_LOADING_STATISTIQUES', true);
        api.get(allQuotes)
            .then((res) => {
                commit('SET_ALLQUOTES', res.data);
                commit('SET_IS_LOADING_STATISTIQUES', false);
            }).catch((error) => {
            console.log(error);
        });
    },
}